module.exports = __webpack_public_path__ + "static/media/SFPRODISPLAYREGULAR.aaeac71d.OTF";